import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../Button';
import { s } from './styles';
import { ProvidedImage } from './types';

interface ProvidedImagesTabProps {
	images: ProvidedImage[];
	title: string;
	emptyText: string;
	onImageSelected: (image: Api.IFileAttachment) => void;
}

/** Images the caller already has, such as a support ticket's screenshots; choosing one needs no upload. */
export function ProvidedImagesTab({ images, title, emptyText, onImageSelected }: ProvidedImagesTabProps) {
	if (images.length === 0) {
		return <div className={css(s.providedImagesEmpty)}>{emptyText}</div>;
	}

	return (
		<div className={css(s.providedImagesTab)}>
			<h3 className={css(s.providedImagesTitle)}>{title}</h3>
			<div className={css(s.providedImagesGrid)}>
				{images.map(({ attachment, detail, badge }) => (
					<Button
						key={attachment.id}
						variant='ghost'
						styles={[s.providedImageCard]}
						onClick={() => onImageSelected(attachment)}
						disabled={!attachment.url}
						aria-label={badge ? `Insert ${attachment.fileName} (${badge})` : `Insert ${attachment.fileName}`}
					>
						<span className={css(s.providedImageFrame)}>
							{badge ? <span className={css(s.providedImageBadge)}>{badge}</span> : null}
							{attachment.url ? (
								<img className={css(s.providedImage)} src={attachment.url} alt='' />
							) : (
								<span className={css(s.providedImageMissing)}>No preview</span>
							)}
						</span>
						<span className={css(s.providedImageName)} title={attachment.fileName}>
							{attachment.fileName}
						</span>
						{detail ? <span className={css(s.providedImageDetail)}>{detail}</span> : null}
					</Button>
				))}
			</div>
		</div>
	);
}
